// extracted by mini-css-extract-plugin
export default {"product-item":"TrendingProducts_product-item__PIHyt","trend-product__name":"TrendingProducts_trend-product__name__8L0aI"};